import { Component} from '@angular/core';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ShoppingModel} from '../../models/shopping.model';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import {AngularFireDatabase} from 'angularfire2/database';
import { FormGroup, FormBuilder} from '@angular/forms';
import {AuthenticationService} from '@app/core/authentication/authentication.service';
import {UtilityService} from '../core/utils.service';
import {AccreditedService} from '@app/accredited/accredited.service';
import {AccreditedModel} from '../../models/accredited.model';
import {ReceiptModel} from '../../models/receipt.model';

@Component({
  selector: 'app-accredited-receipt',
  templateUrl: './accredited-receipt.component.html',
  styleUrls: ['./accredited-receipt.component.scss']
})
export class AccreditedReceiptComponent {
  selectedReceipt: ReceiptModel;
  receipts: ReceiptModel[] = [];
  cupomModalReference: NgbModalRef;
  isLoading: boolean | false;
  accrediteds: AccreditedModel[] = [];
  page = 1;
  accreditedId: any = null;

  constructor(private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private router: Router,
              private authenticationService: AuthenticationService,
              private accreditedService: AccreditedService,
              private db: AngularFireDatabase,
              private util: UtilityService) {
    this.util.setBarBackground('273e5d');
    this.util.setBarTextColor('ffffff');
    this.accreditedId = this.route.snapshot.paramMap.get('accreditedId');
    this.accreditedService.list().subscribe(  accrediteds => {
      this.accrediteds = accrediteds;
    });

    this.accreditedService.listReceipts(this.accreditedId).subscribe(  receipts => {
      this.receipts = receipts;
    });
  }

  navbarLeftText() {
    if (this.receipts.length === 1) {
      return `${this.receipts.length} recibo`;
    }
    return `${this.receipts.length} recibos`;
  }

  openQrCodeModal(item: ReceiptModel, content: any) {
    this.selectedReceipt = item;
    this.cupomModalReference = this.modalService.open(content,
      { windowClass: 'modal-centered modal-md modal-details' });
  }

  changeAccredited(itemId: any) {
    console.log('id', itemId);
    if (itemId === 'null') {
      this.router.navigate([`/accredited/receipts`], {replaceUrl: true});
      return;
    } else {
      this.router.navigate([`/accredited/receipts`, itemId], {replaceUrl: true});
      this.accreditedService.listReceipts(itemId).subscribe(  receipts => {
        this.receipts = receipts;
      });
    }
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/accredited-receipt/accredited-receipt.component.ts